import { NavLink } from "react-router-dom";

/**
 * Navegación inferior fija con las cinco pestañas de la sección 8.1.
 *
 * POR QUÉ SON CINCO Y NO SEIS
 *   *Ajustes* se abre desde Inicio y la ficha de jugador es una ruta completa con botón atrás.
 *   La sección 8.1 lo fija así y no se negocia por comodidad: seis pestañas a 360 px dejan cada
 *   objetivo en 60 px de ancho y el pulgar deja de acertar.
 *
 * ALTO Y ÁREA SEGURA
 *   60 px por pestaña, por encima de los 44 px que exige la sección 8.1, y el relleno de
 *   `safe-area-inset-bottom` para que la barra de gestos del teléfono no se coma la fila.
 */

interface Tab {
  to: string;
  label: string;
  /** Glifo tipográfico, nunca un emoji: la sección 8.4 no admite iconos decorativos. */
  glyph: string;
  end: boolean;
}

const TABS: Tab[] = [
  { to: "/", label: "Inicio", glyph: "▲", end: true },
  { to: "/plantilla", label: "Plantilla", glyph: "▤", end: false },
  { to: "/mercado", label: "Mercado", glyph: "€", end: false },
  { to: "/recomendar", label: "Recomendar", glyph: "✦", end: false },
  { to: "/alineacion", label: "Alineación", glyph: "⬢", end: false },
];

export function BottomTabs() {
  return (
    <nav
      aria-label="Navegación principal"
      className="pb-safe fixed inset-x-0 bottom-0 z-30 border-t border-border bg-paper/90 backdrop-blur"
    >
      <ul className="mx-auto grid max-w-content grid-cols-5">
        {TABS.map((tab) => (
          <li key={tab.to}>
            <NavLink
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                [
                  "flex min-h-[60px] flex-col items-center justify-center gap-0.5 px-0.5 py-1.5",
                  "text-center text-[10px] font-semibold uppercase tracking-wider no-underline",
                  isActive ? "text-pitch" : "text-muted",
                ].join(" ")
              }
            >
              <span
                aria-hidden="true"
                className="font-display text-[17px] leading-none"
              >
                {tab.glyph}
              </span>
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
